import { stepRentalVehicleExpenseLookup as expenseLookup, emptyClaimCode } from './claimCodeMapper';
import { mapToRentalVehicleExpense } from './expenseMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section8.areYouClaimingForRentalVehicleExcess',
      answer: data.areYouClaimingForRentalVehicleExcess,
      claimTypeCode: claimCode,
    },
    {
      question: 'section8.nameOfThePersonDrivingTheCar',
      answer: data.nameOfThePersonDrivingTheCar,
      claimTypeCode: claimCode,
    },
    {
      question: 'section8.driverDateOfBirth',
      answer: data.driverDateOfBirth,
      claimTypeCode: claimCode,
    },
  ];
}

function getExpenseClaimCode(data) {
  if (data.areYouClaimingForRentalVehicleExcess === 'true') {
    return expenseLookup.areYouClaimingForRentalVehicleExcess;
  }
  return emptyClaimCode;
}

function mapToExpenses(data) {
  const claimCode = getExpenseClaimCode(data);
  if (claimCode === emptyClaimCode) return [];
  return mapToRentalVehicleExpense(data, claimCode);
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepRentalVehicleDataMapper.js